import { useCallback } from 'react'

type RecaptchaEnterpriseWindow = Window & {
  grecaptcha?: {
    enterprise: {
      ready: (callback: () => void) => void
      execute: (siteKey: string, options: { action: string }) => Promise<string>
    }
  }
}

const SITE_KEY = '6LeBPtorAAAAAO_GmtTdZQ7mHP7X9mzKcRuqMz6q'

export type RecaptchaAction = 'LOGIN' | 'ANSWER_QUESTION'

type UseRecaptchaEnterpriseReturn = {
  executeRecaptcha: (action: RecaptchaAction) => Promise<string | null>
  isRecaptchaLoaded: () => boolean
}

export const useRecaptchaEnterprise = (): UseRecaptchaEnterpriseReturn => {
  const isRecaptchaLoaded = useCallback((): boolean => {
    const win = window as RecaptchaEnterpriseWindow
    return !!(
      win.grecaptcha?.enterprise?.ready && win.grecaptcha?.enterprise?.execute
    )
  }, [])

  const executeRecaptcha = useCallback(
    async (action: RecaptchaAction): Promise<string | null> => {
      const win = window as RecaptchaEnterpriseWindow

      if (!isRecaptchaLoaded()) {
        return null
      }

      try {
        return await new Promise((resolve, reject) => {
          win.grecaptcha!.enterprise.ready(async () => {
            try {
              const token = await win.grecaptcha!.enterprise.execute(SITE_KEY, {
                action
              })
              resolve(token)
            } catch (error) {
              reject(error)
            }
          })
        })
      } catch (error) {
        return null
      }
    },
    [isRecaptchaLoaded]
  )

  return {
    executeRecaptcha,
    isRecaptchaLoaded
  }
}
